<template>
  <div class="project-page" v-if="ready">
    <v-container fluid>
      <project-form
        :project="localProject"
        :patient="patient"
        @on-submit="update"
        @on-cancel="dialog = true"
        @on-product-click="goToProduct"
        @on-transfer-click="syncAndSetDelivered"
      ></project-form>

      <v-snackbar color="success" v-model="showSnackbar" :timeout="2000" top>
        {{ textSnackbar }}
        <v-btn text @click="showSnackbar = false">Fermer</v-btn>
      </v-snackbar>

      <!-- Confirmation dialog -->
      <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <v-card-title class="headline">Annulation</v-card-title>
          <v-card-text>Toutes modifications seront perdues !</v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="red" :to="{name: 'LocalPatientList'}" dark text>Oui</v-btn>
            <v-btn @click="dialog = false" text color="black">Non</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

import ProjectForm from "./components/ProjectForm";
import { synchronization } from "@/mixins/synchronization";

export default {
  name: "ProjectPage",
  mixins: [synchronization],
  components: {
    ProjectForm
  },
  data() {
    return {
      ready: false,
      localProject: null,
      patient: null,

      showSnackbar: false,
      textSnackbar: "",
      dialog: false
    };
  },
  computed: {
    ...mapState({
      project: state => state.projects.project
    })
  },
  methods: {
    ...mapMutations({
      setProject: "projects/setProject",
      cleanProject: "projects/cleanProject"
    }),

    ...mapActions({
      cleanProject: "projects/cleanProject",
      getLocalProject: "projects/getLocalProject",
      getLocalPatient: "patients/getLocalPatient"
    }),

    // Load project
    async loadProject() {
      try {
        // Clean project state
        this.cleanProject();

        // Get project
        const projectUuid = this.$route.params.projectUuid;
        const project = await this.getLocalProject(projectUuid);

        // Set project state
        this.setProject(project);

        // Deep clone
        this.localProject = JSON.parse(JSON.stringify(this.project));
      } catch (error) {
        alert(error);
      }
    },

    // Get all we need (Project/Patient)
    async getAll() {
      try {
        this.patient = await this.getLocalPatient(
          this.localProject.patient_uuid
        );
        this.ready = true;
      } catch (error) {
        alert(error);
      }
    },

    // Update local project
    async update() {
      try {
        // Update project
        const projectUuid = this.$route.params.projectUuid;
        await this.$db.projects.update(projectUuid, this.localProject);
        await this.$db.projects.update(projectUuid, { updated: 1 });
        const project = await this.$db.projects.get(projectUuid);

        // Delete useless properties
        delete project.local_version;
        delete project.server_version;
        delete project.updated;

        // Set new project
        this.setProject(project);

        this.textSnackbar = "Projet mis à jour !";
        this.showSnackbar = true;
      } catch (error) {
        alert(error);
      }
    },

    // Open product based on the selected product
    goToProduct() {
      switch (this.localProject.product_model) {
        case "NECK_BRACE":
          this.$router.push({ name: "NeckBraceProduct" });
          break;
        case "MOLDED_SEAT":
          this.$router.push({ name: "MoldedSeatProduct" });
          break;
        case "OTN":
          this.$router.push({ name: "OtnProduct" });
          break;
        case "LIFT":
          this.$router.push({ name: "LiftProduct" });
          break;
        case "RETOUCHING_REPAIR":
          this.$router.push({ name: "RetouchingRepairProduct" });
          break;
        case "SEAT":
          this.$router.push({ name: "SeatProduct" });
          break;
        case "POSITIONING_SEAT":
          this.$router.push({ name: "PositioningSeatProduct" });
          break;
        case "UPPER_LIMB_ORTHOSIS":
          this.$router.push({ name: "UpperLimbProduct" });
          break;
        case "LOWER_LIMB_ORTHOSIS":
          this.$router.push({ name: "LowerLimbProduct" });
          break;
        case "CORSET":
          this.$router.push({ name: "CorsetProduct" });
          break;

        default:
          break;
      }
    },

    // Sync project and model and set project delivered
    async syncAndSetDelivered() {
      try {
        await this.synchronize(this.localProject);

        this.textSnackbar = "Projet synchronisé et livré!";
        this.showSnackbar = true;
      } catch (error) {
        console.log(error);
      }
    }
  },
  async mounted() {
    await this.loadProject();
    await this.getAll();
  },
  beforeDestroy() {
    this.cleanProject();
  }
};
</script>

<style lang="scss">
</style>
